module.exports = __webpack_public_path__ + "static/img/TMBcharacterPhotos_0000_theJinn.7fa10a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/TMBcharacterPhotos_0000_theJinn.jpg
// module id = lehf
// module chunks = 1